/* Facetten-Filter & Sortierung – nutzt die Section Rendering API */
const { debounce } = window.themeHelpers;

const sectionEl = document.querySelector('[data-collection-section]');
const sectionId = sectionEl?.dataset.sectionId;

function collectParams(form) {
  const params = new URLSearchParams();
  const formData = new FormData(form);
  for (const [key, value] of formData.entries()) {
    if (value !== '') params.append(key, value);
  }
  const currentSort = new URLSearchParams(window.location.search).get('sort_by');
  if (currentSort && !params.has('sort_by')) params.set('sort_by', currentSort);
  return params;
}

async function renderPage(searchParams, { push = true } = {}) {
  if (!sectionId) return;
  const results = document.querySelector('[data-collection-results]');
  results?.setAttribute('aria-busy', 'true');
  const url = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`;
  try {
    const response = await fetch(`${url}${searchParams ? '&' : '?'}section_id=${sectionId}`);
    const text = await response.text();
    const parsed = new DOMParser().parseFromString(text, 'text/html');

    const newResults = parsed.querySelector('[data-collection-results]');
    if (results && newResults) results.innerHTML = newResults.innerHTML;

    const newActive = parsed.querySelector('[data-active-facets]');
    document.querySelectorAll('[data-active-facets]').forEach((el) => {
      if (newActive) el.innerHTML = newActive.innerHTML;
    });

    const newCount = parsed.querySelector('[data-results-count]');
    document.querySelectorAll('[data-results-count]').forEach((el) => {
      if (newCount) el.textContent = newCount.textContent;
    });

    document.querySelectorAll('[data-facets-form]').forEach((form) => {
      const newForm = parsed.querySelector('[data-facets-form]');
      if (!newForm) return;
      form.querySelectorAll('details[data-facet]').forEach((group) => {
        const source = newForm.querySelector(`details[data-facet="${group.dataset.facet}"]`);
        if (!source) return;
        const wasOpen = group.hasAttribute('open');
        group.innerHTML = source.innerHTML;
        group.toggleAttribute('open', wasOpen);
      });
    });

    if (push) history.pushState({ facets: true }, '', url);
  } catch (e) {
    window.location.href = url;
  } finally {
    results?.removeAttribute('aria-busy');
  }
}

class FacetFiltersForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => e.preventDefault());
    this.debouncedChange = debounce(() => renderPage(collectParams(this.form).toString()), 500);
    this.form.addEventListener('input', (e) => {
      if (e.target.type === 'number') this.debouncedChange();
      else renderPage(collectParams(this.form).toString());
    });
  }
}
if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);

/* Aktive Filter-Pills & „Alle löschen“ */
document.addEventListener('click', (e) => {
  const pill = e.target.closest('[data-facet-remove]');
  if (!pill) return;
  e.preventDefault();
  const url = new URL(pill.href, window.location.origin);
  renderPage(url.searchParams.toString());
});

/* Sortierung */
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-sort-select]');
  if (!select) return;
  const params = new URLSearchParams(window.location.search);
  params.set('sort_by', select.value);
  params.delete('page');
  renderPage(params.toString());
});

/* „Mehr laden“ */
class LoadMore extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', async (e) => {
      const button = e.target.closest('[data-load-more]');
      if (!button) return;
      e.preventDefault();
      const original = button.textContent;
      button.textContent = window.themeStrings.loading;
      button.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(button.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId || sectionId);
        const response = await fetch(url);
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = parsed.querySelector('.product-grid--collection');
        const currentGrid = document.querySelector('.product-grid--collection');
        if (newGrid && currentGrid) {
          currentGrid.append(...newGrid.children);
        }
        const newLoadMore = parsed.querySelector('load-more');
        if (newLoadMore) {
          this.replaceWith(newLoadMore);
        } else {
          this.remove();
        }
      } catch (err) {
        button.textContent = original;
        button.removeAttribute('aria-disabled');
      }
    });
  }
}
if (!customElements.get('load-more')) customElements.define('load-more', LoadMore);

window.addEventListener('popstate', () => {
  renderPage(new URLSearchParams(window.location.search).toString(), { push: false });
});
